import { IPostRecord } from '#types/records';
import { atom, useRecoilState } from 'recoil';

export const $chartFormDataState = atom<IPostRecord>({
  key: 'chartFormDataState',
  default: {
    records: [],
    comment: ''
  }
});

export const useChartFormDataRecoil = () => {
  const [chartFormData, setChartFormData] = useRecoilState($chartFormDataState);

  return { chartFormData, setChartFormData };
};
